import React, { useState, useEffect, useCallback } from "react";
import { producaov2 as api } from "../../../../services/apis";
import { Icon, Loader } from "semantic-ui-react";
import {
  Container,
  Content,
  Title,
  ContainerInputSearch,
  Input,
  CreateButton,
  Cards,
} from "./styles";
import swal from "sweetalert";
import { withRouter } from "react-router-dom";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import Card from "./Card";
import RemoveModal from "./RemoveModal";
import { isAuthAdmin } from "../../../../services/auth";

const ListarBandeiras = (props) => {
  const [removeModal, setRemoveModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [bandeiras, setBandeiras] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  const removeModalOpen = (name, id) => {
    setSelectedItem({ name, id });
    setRemoveModal(true);
  };

  const deleteBandeira = useCallback(
    (id) => {
      api.delete(`/admin/bandeira/${id}`).then(async (res) => {
        let array = {
          local: "bandeiras",
          texto: `deletou a bandeira id=${id}`,
        };
        await api.post("system_logs", { acao: JSON.stringify(array) });
        const newBandeiras = [...bandeiras].filter(
          (bandeira) => bandeira.id !== id
        );
        setBandeiras(newBandeiras);
      });
    },
    [bandeiras]
  );
  useEffect(() => {
    loadAuth();
    loadBandeiras();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const loadBandeiras = () => {
    api
      .get("/bandeira")
      .then(async (res) => {
        let array = { local: "bandeiras", texto: "listou as bandeiras" };
        await api.post("system_logs", { acao: JSON.stringify(array) });
        setBandeiras([...bandeiras, ...res.data]);
        setLoading(false);
      })
      .catch((err) => {
        swal("Não foi possível carregar as bandeiras", err, "");
      });
  };

  return (
    <>
      <Container>
        <AdminMenu />

        {loading ? (
          <Loader active inline="centered" size="massive" />
        ) : (
          <Content>
            <Title>Bandeiras Cartão</Title>

            <ContainerInputSearch className="ui fluid left icon input">
              <Input
                type="search"
                placeholder="Procurar bandeira..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <Icon name="search icon" />

              <CreateButton to="/admin/bandeiras_cart/criar">
                Criar
              </CreateButton>
            </ContainerInputSearch>

            {bandeiras.length > 0 ? (
              <Cards>
                {bandeiras
                  .filter((bandeira) =>
                    bandeira.nome.toLowerCase().includes(search.toLowerCase())
                  )
                  .map((bandeira, index) => (
                    <Card
                      key={index}
                      remove={removeModalOpen}
                      nome={bandeira.nome}
                      img={bandeira.img}
                      id={bandeira.id}
                    />
                  ))}
              </Cards>
            ) : (
              <h1>Nenhuma bandeira encontrada</h1>
            )}
          </Content>
        )}
      </Container>

      <RemoveModal
        deleteBandeira={deleteBandeira}
        handler={setRemoveModal}
        active={removeModal}
        item={selectedItem}
      />
    </>
  );
};

export default withRouter(ListarBandeiras);
